import {createConnectTransport,} from "@connectrpc/connect-web";
import {createClient, Interceptor} from "@connectrpc/connect";
import type {GenService} from "@bufbuild/protobuf/codegenv2";
import {useMemo} from "react";
import { tokenKey } from "./constant";

const authInjector: Interceptor = (next) => async (req) => {
    const token = localStorage.getItem(tokenKey);
    req.header.set("X-MyTest-Client", `mytest-client`);
    if (token) {
        req.header.set("Authorization", `Bearer ${token}`);
    }

    return await next(req);
};


const transport = createConnectTransport({
    baseUrl: "/",
    interceptors: [authInjector]
});

export function useClient<T extends GenService<any>>(service: T) {
    // We memoize the client, so that we only create one instance per service.
    return useMemo(() => {
        const client = createClient(service, transport);
        return client;
    }, [service]);
}

